import { useState, useEffect, React } from "react";
import Swal from "sweetalert2";
import {
  afterPlanFetchApi,
  updateQuickQuoteCompanywise,
  AddonApi,
  updateAddonApi,
  updateDatabase,
} from "../../Api/Api";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { getMaxAge, premiumDetails } from "../../helper/common";
import { FaPlus } from "react-icons/fa6";

const Star_Addon = () => {
  const [addonlist, setAddonlist] = useState([]);
  const [stopLoading, setStopLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState();
  const [maxAge, setMaxAge] = useState("");

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const unique_id = params.get("req_id");
  const plan_id = params.get("plan_id");
  const c_id = params.get("c_id");

  const handleError = (message) => {
    Swal.fire({
      title: "Error!",
      text: message,
      icon: "error",
      confirmButtonText: "OK",
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.reload();
      }
    });
    setStopLoading(true);
  };

  const getAddon = async () => {
    try {
      const response = await AddonApi(c_id, plan_id).then((response) => {
        setAddonlist(response.addon_data.data);
      });
    } catch (error) {
      setStopLoading(true);
      handleError("Oops there is an error !");
    }
  };

  useEffect(() => {
    let response = getAddon();
    console.log("response", response);
  }, []);
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-lg-8 ">
            <div className="nextfatchtop ">
              <div className="row text-center py-0">
                <div className="col align-self-center">
                  <div className="nextimg ">
                    <img
                      // src={
                      //   apiResponse.response.insurerLogo ||
                      //   apiResponse.request.insurerLogo
                      // }
                      alt="Image"
                      height={60}
                      width={70}
                    />
                  </div>
                </div>
                <div className="col align-self-center nexcont">
                  <div className="nexthead text-left">
                    <h1 className="nfh1 afterlogo">
                      {/* {apiResponse.response.planName} */}
                      <br />
                    </h1>
                  </div>
                </div>
                <div className="col align-self-center">
                  <div className="nexthead ">
                    <p className="nfh1 cash">
                      <i className="fa fa-building" aria-hidden="true" />{" "}
                      <span className="hospitalnum">
                        {" "}
                        {c_id == "ICICI"
                          ? "9,700"
                          : c_id == "care"
                          ? "10,632"
                          : c_id == "GoDigit"
                          ? "16,334"
                          : ""}
                      </span>
                      Cashless hospitals in India
                    </p>
                  </div>
                </div>
                <div className="col align-self-center">
                  <div className="nextcover text-center">
                    <p className="nfh1 colortexdesktop">Cover Amount</p>

                    <FormControl sx={{ m: 1, minWidth: "60%" }}>
                      <Select
                        // value={coverVal}
                        onChange={(e) => {
                          // updateCoverAmount(e.target.value);
                        }}
                        sx={{
                          boxShadow: "none",
                          height: "20px", // Adjust height
                          padding: "0px", // Adjust padding
                          ".MuiOutlinedInput-notchedOutline": { border: 0 },
                          "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                            {
                              border: 0,
                            },
                          "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                              border: 0,
                            },
                        }}
                      >
                        {/* {CoverAmountHandelChnage.map((data, i) => {
                          return (
                            <MenuItem value={data} key={i}>
                            
                              {formatAmount(data)}
                            </MenuItem>
                          );
                        })
                        } */}
                      </Select>
                    </FormControl>
                  </div>
                </div>
              </div>
            </div>
            <div className="nextfatchtopmobile">
              <div className="blockdivmobilefetchplane">
                <div className="nextfatchtopmobileplanename">
                  <div className="nexthead text-left">
                    <h1 className="nfh1 afterlogo">
                      {/* {apiResponse.response.planName} */}
                    </h1>
                  </div>
                </div>
                <div className="flexdisplayafterfetchplane">
                  <div className="nextfatchtopmobileimg">
                    <img
                      // src={
                      //   apiResponse.response.insurerLogo ||
                      //   apiResponse.request.insurerLogo
                      // }
                      alt="Image"
                      height={60}
                      width={70}
                    />
                  </div>
                  <div className="col align-self-center">
                    <div className="nexthead ">
                      <p className="nfh1 cash">
                        <i className="fa fa-building" aria-hidden="true" />{" "}
                        <span className="hospitalnum">
                          {" "}
                          {c_id == "ICICI"
                            ? "9,700"
                            : c_id == "care"
                            ? "10,632"
                            : c_id == "GoDigit"
                            ? "16,334"
                            : ""}
                        </span>
                        Cashless hospitals in India
                      </p>
                    </div>
                  </div>
                </div>

                <div className="flexdisplayafterfetchplane">
                  <div className="col mobilecoverafterfetch">
                    <div className="nextcover text-center">
                      <p className="nfh1 colortex">Cover Amount</p>

                      <FormControl sx={{ m: 1, minWidth: "60%" }}>
                        <Select
                          // value={coverVal}
                          onChange={(e) => {
                            // updateCoverAmount(e.target.value);
                          }}
                          sx={{
                            boxShadow: "none",
                            height: "20px", // Adjust height
                            padding: "0px", // Adjust padding
                            ".MuiOutlinedInput-notchedOutline": {
                              border: 0,
                            },
                            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                          }}
                        >
                          {/* {CoverAmountHandelChnage.map((data) => {
                            return <MenuItem value={data}>{data} lac</MenuItem>;
                          })} */}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="nextsection">
              <h1 className="nfh1 colortex">Policy and Period</h1>

              {maxAge < 96 ? (
                <>
                  <div className="row text-center py-0">
                    <div className="col align-self-center">
                      <div
                        className="form-group form-check ppriod paddingfixtenure"
                        onClick={() => {
                          // updatePerTenure("1 Year");
                        }}
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          defaultChecked=""
                          style={{ visibility: "hidden" }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="exampleCheck1"
                        >
                          <strong className="afterplan-strong">
                            {" "}
                            1 Year
                            {/* {oneData ? formatToINR(oneData) : ""} */}
                          </strong>
                        </label>
                      </div>
                    </div>
                    <div className="col align-self-center">
                      <div
                        className={`form-group form-check ppriod paddingfixtenure ${
                          apiResponse.request.tenure === "2 Year"
                            ? "oneshowdata"
                            : ""
                        }`}
                        onClick={() => {
                          // updatePerTenure("2 Year");
                        }}
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ visibility: "hidden" }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="exampleCheck1"
                        >
                          <strong className="afterplan-strong">
                            {" "}
                            <>
                              2 Year
                              {/* {twoData ? formatToINR(twoData) : ""} */}
                            </>
                          </strong>
                        </label>
                      </div>
                    </div>
                    <div className="col align-self-center">
                      <div
                        className={`form-group form-check ppriod paddingfixtenure ${
                          apiResponse.request.tenure === "3 Year"
                            ? "oneshowdata"
                            : ""
                        }`}
                        onClick={() => {
                          // updatePerTenure("3 Year");
                        }}
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ visibility: "hidden" }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="exampleCheck1"
                        >
                          <strong className="afterplan-strong">
                            {" "}
                            3 Year
                            {/* {threeData ? formatToINR(threeData) : ""} */}
                          </strong>
                        </label>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
            </div>

            {apiResponse.response.insurerName == "hdfc" && (
              <div className="nextsection ">
                {addonlist &&
                  addonlist.map((element) => {
                    if (element.code == "deductible") {
                      return maxAge < element.age ? null : (
                        <div className="deductible-section">
                          <h1 className="nfh1 colortex">Deductible Discount</h1>
                          <p className="para">
                            Lorem Ipsum is simply dummy text of the printing and
                            typesetting industry. Lorem Ipsum has been the
                            industry
                          </p>
                          <div className="reccard" key={element.code}>
                            <div className="row text-center py-0 reccardline">
                              <div className="col align-self-center reccard-img">
                                <div className="nextimg">
                                  <img
                                    src={apiResponse.response.insurerLogo}
                                    alt="Image"
                                    className="recimg"
                                  />
                                </div>
                              </div>
                              <div className="col align-self-center">
                                <div
                                  className="nexthead"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <h1 className="nfh1 addonname">
                                    {element.name}
                                  </h1>
                                </div>
                              </div>
                              <div className="col align-self-center">
                                <button
                                  className="recbtn"
                                  onClick={() => {
                                    // putAddon(element.code);
                                  }}
                                >
                                  <FaPlus
                                    style={{
                                      marginTop: "-2px",
                                      height: "13px",
                                    }}
                                  />
                                  Add
                                </button>
                              </div>
                            </div>
                            <div className="addon-extra-hdfc">
                              <p className="reccard-des">
                                Description:
                                <span className="des-span">
                                  {element.description}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
              </div>
            )}
            <div className="nextsection ">
              <h1 className="nfh1 colortex">Recomended Add-Ons</h1>

              {/* company - star */}
              {/* {addonlist &&
                addonlist.map((item, index) => {
                  if (
                    item.code == "addOnCoverSection2Deduction" &&
                    c_id == "star"
                  ) {
                    return maxAge < item.age ? null : (
                      <div className="reccard" key={item.code}>
                        <div className="row text-center py-0 reccardline">
                          <div className="col align-self-center reccard-img">
                            <div className="nextimg">
                              <img
                                src={apiResponse.response.insurerLogo}
                                alt="Image"
                                className="recimg"
                              />
                            </div>
                          </div>
                          <div className="col align-self-center">
                            <div
                              className="nexthead"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <h1 className="nfh1 addonname">{item.name}</h1>
                              {item.code === "addOnCoverSection2Deduction" && (
                                <div
                                  className="discriptionse"
                                  style={{ marginRight: "-23px" }}
                                >
                                  <span className="insurtext">
                                    <FormControl
                                      variant="standard"
                                      sx={{ minWidth: "100%" }}
                                    >
                                      {apiResponse.response.sumInsured <=
                                      2000000 ? (
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          onChange={(e) => {
                                            setStarDeductVal(e.target.value);
                                          }}
                                          value={starDeductVal}
                                        >
                                          <MenuItem value={25000}>
                                            25000
                                          </MenuItem>
                                          <MenuItem value={50000}>
                                            50000
                                          </MenuItem>
                                        </Select>
                                      ) : (
                                        <Select
                                          labelId="demo-simple-select-standard-label"
                                          id="demo-simple-select-standard"
                                          onChange={(e) => {
                                            setStarDeductVal(e.target.value);
                                          }}
                                          value={starDeductVal}
                                        >
                                          <MenuItem value={25000}>
                                            25000
                                          </MenuItem>
                                          <MenuItem value={50000}>
                                            50000
                                          </MenuItem>
                                          <MenuItem value={100000}>
                                            100000
                                          </MenuItem>
                                        </Select>
                                      )}
                                    </FormControl>
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="col align-self-center buttonaddon">
                            {finalAddonList?.addonlist &&
                            finalAddonList?.addonlist.some(
                              (data) => data.addonCode == item.code
                            ) ? (
                              <button className="recbtn" disabled={true}>
                                Added
                              </button>
                            ) : (
                              <button
                                className="recbtn"
                                onClick={() => {
                                  putAddon(item.code);
                                }}
                              >
                                <FaPlus
                                  style={{
                                    marginTop: "-2px",
                                    height: "13px",
                                  }}
                                />
                                Add
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="addon-extra-hdfc">
                          <p className="reccard-des">
                            Description:{" "}
                            <span className="des-span">{item.description}</span>
                          </p>
                        </div>
                      </div>
                    );
                  }
                })} */}
            </div>
          </div>
          <div className="col-lg-4">
            {/* <Summary
                  nextPage="proposal"
                  setOneData={setOneData}
                  setTwoData={setTwoData}
                  setThreeData={setThreeData}
                  planInfo={apiResponse}
                  addonsArray={addonArr}
                  setAddonArr={setAddonArr}
                  setApiResponse={setApiResponse}
                  apiResponse={apiResponse}
                  setBeforeAddon={setBeforeAddon}
                  addonPrev={addonPrev}
                  setAddonPrev={setAddonPrev}
                  addonlist={addonlist}
                  addondataList={addonDataList}
                  setAddonDataList={setAddonDataList}
                  setApiData={setApiData}
                  apidata={apidata}
                  socketManager={socketManager}
                  loading={loading}
                  setLoading={setLoading}
                  finalAddonList={finalAddonList}
                  setFinalAddonList={setFinalAddonList}
                  setAddonJson={setAddonJson}
                  proposerDataAfter={proposerDataAfter}
                  setPreviousAddon={setPreviousAddon}
                  previousAddon={previousAddon}
                  addonJson={addonJson}
                  settingDataAfter={settingData}
                  extData={extData}
                  setExtData={setExtData}
                  oneData={oneData}
                  twoData={twoData}
                  threeData={threeData}
                /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Star_Addon;
